import axios from "axios";

const { REACT_APP_BACKEND_API_URL } = process.env;

export const apiPostMeetingSurvet = async (payload, authToken) => {
    try {
        const url = `${REACT_APP_BACKEND_API_URL}/meeting/post-meeting-survey`;
        const response = await axios.post(url, payload, { headers: { Authorization: `Bearer ${authToken}` } });
        return response?.data;
    } catch (e) {
        throw e?.response?.data ? e?.response?.data : e;
    }
};
